var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInscricoes = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "D722516E-CD73-4914-9982-FE40F7F97058")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Modelos-Originais",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "original",
    transform: "translate(-105.000000, -736.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 721.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119,19 C120.104569,19 121,19.8954305 121,21 L121,33 C121,34.1045695 120.104569,35 119,35 L107,35 C105.895431,35 105,34.1045695 105,33 L105,21 C105,19.8954305 105.895431,19 107,19 L119,19 Z M111.314384,23.3767874 C110.801548,23.3767874 110.378877,23.7628276 110.321112,24.2601663 L110.314384,24.3767874 L110.314384,29.6232126 C110.314384,29.8175036 110.370983,30.0075869 110.477264,30.1702318 C110.757795,30.599537 111.312166,30.7421922 111.760097,30.5184947 L111.861403,30.4603326 L115.875784,27.83712 C115.991495,27.7615085 116.090274,27.6627298 116.165885,27.5470193 C116.446416,27.1177141 116.354464,26.5527161 115.96973,26.2323059 L115.875784,26.16288 L111.861403,23.5396674 C111.698758,23.4333865 111.508675,23.3767874 111.314384,23.3767874 Z M117.5,17 C117.776142,17 118,17.2238576 118,17.5 C118,17.7761424 117.776142,18 117.5,18 L108.5,18 C108.223858,18 108,17.7761424 108,17.5 C108,17.2238576 108.223858,17 108.5,17 L117.5,17 Z M115.5,15 C115.776142,15 116,15.2238576 116,15.5 C116,15.7761424 115.776142,16 115.5,16 L110.5,16 C110.223858,16 110,15.7761424 110,15.5 C110,15.2238576 110.223858,15 110.5,15 L115.5,15 Z",
    id: "Combined-Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInscricoes, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/inscricoes.36b92836.svg";
export { ForwardRef as ReactComponent };